@if (loaderService.isLoading | async) {
  <div class="loader-backdrop">
    <div class="loader-content">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="loading-text">Getting things ready...</p>
    </div>
  </div>
}
